import React, { useEffect, useState } from "react";
import { FaXmark, FaPlus, FaMinus, FaCopy } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { getL2SheetProperty, getQueryArray } from "../../../WorkbookSlice";
import { IoMdArrowDropdown } from "react-icons/io";
import { Dropdown } from "flowbite-react";
import { LiaSortSolid } from "react-icons/lia";
import { useDispatch } from "react-redux";
import { updateLevel2Properties } from "../../../WorkbookSlice";
import CustomSort from "./CustomSort";
import { getSheetControls } from "../../../WorkbookControllingSlice";

const level = {
  column: null,
  dataType: "String",
  order: "DESC",
  _id: "",
};

export default function SortModal({ closeModal, selectedSheetId, VizType }) {
  const Sheetid = selectedSheetId;
  const dispatch = useDispatch();

  const uniqueColumnValues = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "uniqueColumnValues" })
  );

  const mergedArray = useSelector((state) =>
    getQueryArray(state, Sheetid, VizType, uniqueColumnValues)
  );
  console.log(mergedArray);

  const sortArray = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "sort");
  });
  console.log(sortArray);

  let firstItemOfMergedArray = null;
  if (Array.isArray(mergedArray) && mergedArray.length > 0) {
    const indexZeroItem = mergedArray[0];
    console.log(indexZeroItem);
    if (indexZeroItem.dataType === "Date") {
      firstItemOfMergedArray = {
        column: `${indexZeroItem.rename}${indexZeroItem.dateFormat.value}`,
        dataType: indexZeroItem.dataType,
        order: "ASC",
        _id: indexZeroItem._id,
        format: indexZeroItem.dateFormat.value,
        uuid: indexZeroItem.uuid,
        nanoId: indexZeroItem.nanoId,
        yearType: indexZeroItem.yearType,
      };
    } else if (indexZeroItem.dataType === "Number") {
      firstItemOfMergedArray = {
        column: `${indexZeroItem.measure.value}_${indexZeroItem.rename}`,
        dataType: indexZeroItem.dataType,
        order: "ASC",
        _id: indexZeroItem._id,
        measure: indexZeroItem.measure.value,
        uuid: indexZeroItem.uuid,
        nanoId: indexZeroItem.nanoId,
      };
    } else if (indexZeroItem.dataType === "String") {
      firstItemOfMergedArray = {
        column: indexZeroItem.rename,
        dataType: indexZeroItem.dataType,
        order: "ASC",
        _id: indexZeroItem._id,
        uuid: indexZeroItem.uuid,
        nanoId: indexZeroItem.nanoId,
      };
    } else {
      firstItemOfMergedArray = null;
    }
  }
  console.log(firstItemOfMergedArray);
  const [sortLevel, setSortLevel] = useState(
    sortArray.length === 0 && mergedArray.length > 0
      ? [firstItemOfMergedArray]
      : sortArray
  );
  console.log(sortLevel);

  const [selectedRow, setSelectedRow] = useState(null);
  const [error, setError] = useState(null);
  const [customSortModal, setCustomSortModal] = useState(null);
  const temproryColumn = mergedArray[selectedRow];

  useEffect(() => {
    if (
      selectedRow !== null &&
      sortLevel[selectedRow].dataType === "Number" &&
      sortLevel[selectedRow].order === "CUSTOM"
    ) {
      const correctedSortLevel = sortLevel.map((item, index) => {
        if (
          index === selectedRow &&
          item.dataType === "Number" &&
          item.order === "CUSTOM"
        ) {
          return {
            ...item,
            order: "ASC",
          };
        }
        return item;
      });
      setSortLevel(correctedSortLevel);
    }
  }, [sortLevel, selectedRow]);

  const addLevel = () => {
    setSortLevel([...sortLevel, { ...level }]);
  };

  const handleRowSelection = (index) => {
    setSelectedRow(index);
  };

  const handleMinus = (selectedRow) => {
    if (selectedRow !== null) {
      const filteredArray = sortLevel.filter(
        (_, index) => index !== selectedRow
      );
      setSortLevel(filteredArray);
      setSelectedRow(null); // Clear the selected row after deletion
    }
  };

  const handleCopy = (selectedRow) => {
    if (selectedRow !== null) {
      const copiedLevel = { ...sortLevel[selectedRow] };
      setSortLevel([...sortLevel, copiedLevel]);
    }
  };

  const handleOrder = (index, order) => {
    console.log(index, order);

    const updatedLevels = sortLevel.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          order: order,
        };
      }
      return item;
    });
    console.log(updatedLevels);

    setSortLevel(updatedLevels);

    if (order === "CUSTOM") {
      setCustomSortModal("CUSTOM");
    }
  };

  const handleColumnChange = (index, column, isUniqueColumn) => {
    console.log(column);

    console.log(isUniqueColumn);
    const updatedLevels = sortLevel.map((item, i) => {
      console.log(item);
      if (i === index) {
        if (column.dataType === "Date") {
          return {
            ...item,
            order: "ASC",
            column: isUniqueColumn
              ? column.columnName
              : column.dateFormat !== undefined
              ? `${column.rename}${column.dateFormat.value}`
              : `${column.rename}`,
            dataType: column.dataType,
            columnId: column.nanoId,
            format:
              column.dateFormat !== undefined ? column.dateFormat.value : null,
            yearType: column.yearType,
          };
        }
        if (column.dataType === "Number") {
          console.log(isUniqueColumn);
          return {
            ...item,
            order: "DESC",
            column: isUniqueColumn
              ? column.columnName
              : column.measure !== undefined
              ? `${column.measure.value}_${column.rename}`
              : `${column.rename}`,
            dataType: column.dataType,
            columnId: column.nanoId,
          };
        }
        if (column.dataType === "String") {
          console.log(isUniqueColumn);
          return {
            ...item,
            column: `${column.rename}`,
            dataType: column.dataType,
            columnId: column.nanoId,
          };
        }
      }
      return item;
    });
    console.log(updatedLevels);

    setSortLevel(updatedLevels);
  };

  useEffect(() => {
    // Check for duplicate objects
    const hasDuplicates = sortLevel.some(
      (item, index) =>
        sortLevel.findIndex(
          (obj, idx) =>
            idx !== index &&
            obj.column === item.column &&
            obj.dataType === item.dataType &&
            obj.order === item.order
        ) !== -1
    );

    // Check for null columns when there are 3 or more indexes in sortLevel
    const hasNullColumn =
      sortLevel.length >= 3 && sortLevel.some((item) => item.column === null);
    if (hasDuplicates) {
      setError("Duplicate sort levels found.");
    } else if (hasNullColumn) {
      setError("A column is null in sort levels.");
    } else {
      setError(null); // No errors
    }
  }, [sortLevel]);

  const handleOk = (sortLevel) => {
    console.log(sortLevel);
    dispatch(
      updateLevel2Properties({
        reduxKey: "sort",
        Sheetid: Sheetid,
        parentKey: "actions",
        value: sortLevel,
        itemInArray: false,
        index: null,
      })
    );
    closeModal();
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleOk(sortLevel); // Call your function here
    }
  };

  return (
    <>
      <main
        className="fixed inset-0 bg-opacity-50 flex flex-col items-center justify-center z-40"
        onKeyDown={handleKeyDown}
      >
        <main className="w-[40rem] h-auto bg-white shadow-2xl rounded-lg">
          <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg">
            <button className="text-lg font-medium flex items-center justify-start gap-2">
              Sort
              {error !== null && (
                <span className="text-red-700 font-medium">{error}</span>
              )}
            </button>
            <button
              onClick={closeModal}
              className="text-gray-500 hover:text-black"
            >
              <FaXmark />
            </button>
          </header>
          <section className="flex flex-col p-2">
            <div className="h-60 max-h-60 overflow-y-auto">
              <table className="min-w-full border-gray-300 text-gray-700">
                <thead className="sticky top-0 bg-gray-50 z-20">
                  <tr className="bg-gray-50 font-medium">
                    <th className="border border-gray-300 p-[2px] text-left font-normal">
                      By
                    </th>
                    <th className="border border-gray-300 p-[2px] text-left font-normal">
                      Column
                    </th>
                    <th className="border border-gray-300 p-[2px] text-left font-normal">
                      Order
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortLevel.map((item, index) => (
                    <tr
                      key={index}
                      onClick={() => handleRowSelection(index)}
                      className={`cursor-pointer ${
                        selectedRow === index ? "bg-gray-100" : ""
                      }`}
                    >
                      <td className="border p-[2px] font-normal">
                        {index === 0 ? "Sort by" : "Then by"}
                      </td>
                      <td className="border p-[2px] font-normal">
                        <Dropdown
                          label={
                            <button className="text-gray-700 flex items-center justify-between w-56 border border-gray-300 rounded bg-gray-100 p-1">
                              {item.column ? item.column : "Select a column"}
                              <IoMdArrowDropdown className="text-xl text-gray-700" />
                            </button>
                          }
                          arrowIcon={false}
                          dismissOnClick={true}
                          className="w-56 shadow-lg h-44 overflow-y-auto"
                        >
                          {mergedArray.map((column, colIndex) => {
                            console.log(column);
                            const isUniqueColumn =
                              column._id === "groupByFields" ? true : false;

                            return (
                              <Dropdown.Item
                                key={colIndex}
                                className="flex gap-2 items-center w-full truncate"
                                onClick={() =>
                                  handleColumnChange(
                                    index,
                                    column,
                                    isUniqueColumn
                                  )
                                }
                              >
                                {isUniqueColumn ? column.columnName : null}
                                {!isUniqueColumn &&
                                column.dataType === "Number" &&
                                column.measure
                                  ? `${column.measure.value}_${column.rename}`
                                  : null}
                                {!isUniqueColumn &&
                                column.dataType === "Date" &&
                                column.dateFormat
                                  ? `${column.rename}${column.dateFormat.value}`
                                  : null}
                                {!isUniqueColumn && column.dataType === "String"
                                  ? column.rename
                                  : null}
                              </Dropdown.Item>
                            );
                          })}
                        </Dropdown>
                      </td>
                      <td className="border p-[2px] font-normal">
                        {item.dataType === "String" && (
                          <Dropdown
                            label={
                              <button className="text-gray-700 flex items-center justify-start gap-2 w-48 border border-gray-300 rounded bg-gray-100 p-1">
                                <LiaSortSolid className="text-xl text-gray-700" />
                                {item.order === "ASC" && "A To Z"}
                                {item.order === "DESC" && "Z To A"}
                                {item.order === "CUSTOM" && "Custom"}
                              </button>
                            }
                            arrowIcon={false}
                            dismissOnClick={true}
                            className="w-32 shadow-lg"
                          >
                            <Dropdown.Item
                              onClick={() => handleOrder(index, "ASC")}
                              className="flex gap-2 items-center"
                            >
                              A To Z
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => handleOrder(index, "DESC")}
                              className="flex gap-2 items-center"
                            >
                              Z To A
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => handleOrder(index, "CUSTOM")}
                            >
                              Custom
                            </Dropdown.Item>
                          </Dropdown>
                        )}
                        {item.dataType === "Number" && (
                          <Dropdown
                            label={
                              <button className="text-gray-700 flex items-center justify-start gap-2 w-48 border border-gray-300 rounded bg-gray-100 p-1">
                                <LiaSortSolid className="text-xl text-gray-700" />
                                {item.order === "ASC" && "1 To 9"}
                                {item.order === "DESC" && "9 To 1"}
                                {item.order === "CUSTOM" && "Custom"}
                              </button>
                            }
                            arrowIcon={false}
                            dismissOnClick={true}
                            className="w-32 shadow-lg"
                          >
                            <Dropdown.Item
                              onClick={() => handleOrder(index, "ASC")}
                              className="flex gap-2 items-center"
                            >
                              1 To 9
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => handleOrder(index, "DESC")}
                              className="flex gap-2 items-center"
                            >
                              9 To 1
                            </Dropdown.Item>
                          </Dropdown>
                        )}
                        {item.dataType === "Date" && (
                          <Dropdown
                            label={
                              <button className="text-gray-700 flex items-center justify-start gap-2 w-48 border border-gray-300 rounded bg-gray-100 p-1">
                                <LiaSortSolid className="text-xl text-gray-700" />
                                {item.order === "ASC" && "Old To New"}
                                {item.order === "DESC" && "New To Old"}
                                {item.order === "CUSTOM" && "Custom"}
                              </button>
                            }
                            arrowIcon={false}
                            dismissOnClick={true}
                            className="w-32 shadow-lg"
                          >
                            <Dropdown.Item
                              onClick={() => handleOrder(index, "ASC")}
                              className="flex gap-2 items-center"
                            >
                              Old To New
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => handleOrder(index, "DESC")}
                              className="flex gap-2 items-center"
                            >
                              New To Old
                            </Dropdown.Item>
                          </Dropdown>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
          <footer className="w-full flex items-center justify-between p-3 bg-gray-50 rounded-b-lg">
            <div className="w-1/2 gap-4 flex items-center justify-start">
              <button
                className="rounded border p-[2px] text-[16px] text-blue-950"
                onClick={addLevel}
              >
                <FaPlus />
              </button>
              <button
                className="rounded border p-[2px] text-[16px] text-blue-950"
                onClick={() => handleMinus(selectedRow)}
              >
                <FaMinus />
              </button>
              <button
                className="rounded border p-[2px] text-[16px] text-blue-950"
                onClick={() => handleCopy(selectedRow)}
              >
                <FaCopy />
              </button>
            </div>
            <div className="w-1/2 flex items-center justify-end gap-4">
              <button onClick={closeModal} className="w-20 border">
                Close
              </button>
              <button
                disabled={error !== null}
                onClick={() => {
                  handleOk(sortLevel);
                }}
                className={`border ${
                  error !== null
                    ? "bg-gray-400 text-black"
                    : " bg-blue-950 text-white"
                } w-20`}
              >
                Ok
              </button>
            </div>
          </footer>
        </main>
      </main>
      {customSortModal === "CUSTOM" ? (
        <CustomSort
          closeModal={() => setCustomSortModal(false)}
          item={temproryColumn}
          Sheetid={Sheetid}
          sortLevel={sortLevel}
          setSortLevel={setSortLevel}
          selectedRow={selectedRow}
        />
      ) : null}
    </>
  );
}
